/**
 * @typedef {Object} AnchorScrollOverride
 *
 * @description This class is used to override the default anchor scrolling behavior.
 * @example where a link would be overridden:
 * <a href="#section-id">Section</a>
 */
class AnchorScrollOverride {
    constructor(anchor) {
        this.anchor = anchor;
        this.storeHeader = document.querySelector('store-header');
        this.jumpPosition = this.anchor.dataset.jumpPosition;

        const href = this.anchor.getAttribute('href');

        if (!href || href === '#') {
            return;
        }

        this.target = document.querySelector(href);
        this.storeHeader = document.querySelector('store-header');

        this.anchor.addEventListener('click', this.handleClick.bind(this));
    }

    getStoreHeaderHeight() {
        return this.storeHeader ? this.storeHeader.offsetHeight : 0;
    }

    getTargetWindowPosition() {
        return this.target.getBoundingClientRect().top + window.scrollY;
    }

    getCenteredTargetWindowPosition() {
        const headerHeight = this.getStoreHeaderHeight();
        const availableViewportHeight = window.innerHeight - headerHeight;
        const targetHeight = this.target.offsetHeight;
        const centeredPosition = this.getTargetWindowPosition() - headerHeight - (availableViewportHeight / 2) + (targetHeight / 2);

        return Math.max(0, centeredPosition);
    }

    handleClick(e) {
        e.preventDefault();

        const topPosition = this.jumpPosition === 'center'
            ? this.getCenteredTargetWindowPosition()
            : this.getTargetWindowPosition() - this.getStoreHeaderHeight();

        window.scrollTo({
            top: topPosition,
            left: 0,
            behavior: 'smooth',
        });
    }
}

const anchors = document.querySelectorAll('a[href^="#"]');

anchors.forEach((anchor) => {
    new AnchorScrollOverride(anchor);
});
